<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="layout-dialog"
    title="予定日時"
    top="5vh"
    width="580px"
    :visible="dialogVisible2"
    append-to-body
    class="el_dialog"
    @close="close"
  >
    <vab-form ref="form" :model="form" :rules="rules">
      <el-row type="flex" class="flex_center_align">
        <span class="margin_right_36">日時</span>
        <div class="margin_right_16 day_time">
          <vab-time prop="date" :work-change="true" />
        </div>
        <vab-time-input
          v-model="form.startTime"
          prop="startTime"
          error="日時"
          class="work_time"
          :disabled="dateCheck || $baseLodash.isEmpty(form.date)"
          :row-item="{ isUpdate: true }"
        />
        <span class="margin_left_6 margin_right_6">〜</span>
        <vab-time-input
          v-model="form.endTime"
          prop="endTime"
          error="日時"
          class="work_time"
          :disabled="dateCheck || $baseLodash.isEmpty(form.date)"
          :row-item="{ isUpdate: true }"
        />
      </el-row>
    </vab-form>
    <div slot="footer" class="dialog-footer flex_end mg12">
      <div class="flex_start flex_center_align">
        <vab-button :btn-list="btnList" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'ScheduledDatesPopup',
    inject: {
      vmChildData: {
        default: null,
      },
    },
    data() {
      return {
        dialogVisible2: false,
        btnList: [
          {
            name: 'キャンセル',
            type: 'button',
            hidden: false,
            click: () => {
              this.close()
            },
          },
          {
            name: '登録',
            icon: 'answer',
            word: this.$t(
              `validateMessage.${this.$messageCode.I00000411.name}`
            ),
            type: 'button',
            hidden: false,
            click: () => {
              this.$refs['form'].validate((valid) => {
                if (valid) {
                  this.$confirm({
                    msg: this.$t(
                      `validateMessage.${this.$messageCode.I00000410.name}`
                    ),
                    yesTex: '更新',
                    yes: async () => {
                      this.submitForm()
                    },
                  })
                } else {
                  return false
                }
              })
            },
          },
        ],
        form: {
          date: null,
          startTime: null,
          endTime: null,
          index: 0,
        },
        rules: {
          startTime: {
            required: true,
            message: this.$t(
              `validateMessage.${this.$messageCode.E00000467.name}`
            ),
            trigger: ['blur', 'change'],
          },
          endTime: {
            required: true,
            message: this.$t(
              `validateMessage.${this.$messageCode.E00000467.name}`
            ),
            trigger: ['blur', 'change'],
          },
        },
      }
    },
    computed: {
      dateCheck() {
        return this.getFieldValue('date', this.form)
      },
    },
    watch: {
      dateCheck(val) {
        let newVal = val ?? ''
        if (newVal === '') {
          this.$set(this.form, 'startTime', null)
          this.$set(this.form, 'endTime', null)
        }
      },
    },
    methods: {
      submitForm() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.vmChildData.updateTime(this.form)
            this.close()
          }
        })
      },
      close() {
        this.dialogVisible2 = false
        this.$set(this.form, 'date', null)
        this.$set(this.form, 'startTime', null)
        this.$set(this.form, 'endTime', null)
        this.$refs['form'].resetFields()
      },
      setParamsData(dbItem) {
        const { time, timeList } = dbItem
        const date = this.$dayjs(time).format('DD')
        this.$set(this.form, 'date', date)
        const activeDataList = timeList?.filter((item) => item?.active)
        if (activeDataList.length > 0) {
          if (activeDataList[0]?.active) {
            const timeVal = activeDataList[0]?.time?.split('-')
            this.$set(this.form, 'startTime', timeVal[0])
            this.$set(this.form, 'endTime', timeVal[1])
          }
        } else {
          this.$set(this.form, 'startTime', null)
          this.$set(this.form, 'endTime', null)
        }
        this.dialogVisible2 = true
      },
    },
  }
</script>

<style lang="scss" scoped>
  .text_84 {
    font-family: 'Noto Sans JP';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 150%;
    /* identical to box height, or 20px */
    color: #848484;
    margin-bottom: 8px;
  }

  .dialog_item {
    border-bottom: 1px dashed #eee;
    padding-bottom: 16px;
    margin-bottom: 16px;
  }
  .el_dialog {
    ::v-deep .el-dialog__title {
      font-family: 'Noto Sans JP';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 150%;
      color: #003350;
    }
    ::v-deep .el-dialog__header {
      padding: 12px;
    }
    ::v-deep .el-dialog__body {
      padding: 24px;
    }
    ::v-deep .el-dialog__headerbtn {
      top: 12px;
      font-size: 24px;
    }

    ::v-deep .el-dialog__foote {
      border-top: none !important;
    }

    .flex_center_align {
      ::v-deep.btn_box {
        margin-left: 0;
        margin-right: 8px;
      }
    }
  }
  .due_input {
    ::v-deep .el-input {
      width: 80px;
    }
    ::v-deep .el-input__inner {
      width: 80px;
    }
  }
  .input_50 {
    width: 50px;
    ::v-deep .el-input__inner {
      text-align: right;
    }
  }
  .input_60 {
    width: 60px;
    ::v-deep .el-input__inner {
      text-align: center;
    }
  }
  .margin_right_36 {
    margin-right: 36px;
  }
  .margin_right_16 {
    margin-right: 16px;
  }
  .work_time {
    ::v-deep .el-form-item__content {
      width: 60px;
    }
  }
</style>
